

import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class SideNavBarService {

    public showsideBarSummary: boolean = false;
    constructor() {

    }
    public openSidePanel(): void{
        this.showsideBarSummary = true;
        console.log("this.showsideBarSummary",this.showsideBarSummary)
    }
    public triggerOpen(): void{
        this.showsideBarSummary = !this.showsideBarSummary;
    }

    public closeSidePanel(): void{
        this.showsideBarSummary = false;
    }
}
